import React from 'react'
import FooterThree from './FooterThree'

const FooterTwo = () => {
    return <FooterThree />
}

export default FooterTwo
